import React from 'react';

import {Header, Content} from './style';
import Logo from './../../assets/images/amigoo_pet.svg';

const Heading = () => {
    return (
        <Header>
            <Content>
                <img src={Logo} alt="Amigoo Pet"/>
            </Content>
        </Header>
    )
};

export default Heading;